import { FormatHorizontalAlignCenterIcon } from './FormatHorizontalAlignCenterIcon';

/**
 * author: Austin Andrews
 * id 83EE24A9-9D1A-45AA-B4CD-F75F1174F0EB
 * name format-horizontal-align-center
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-horizontal-align-center.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatHorizontalAlignCentreIcon = FormatHorizontalAlignCenterIcon;
export default FormatHorizontalAlignCentreIcon